// extracted by mini-css-extract-plugin
export var alignCenter = "_60-d";
export var bannerShown = "_60-6";
export var buttonContent = "_60-0";
export var cardList = "_60-1";
export var centerContent = "_60-2";
export var chevron = "_60-3";
export var closePanelButton = "_60-k";
export var conversationContextContainer = "_60-l";
export var conversationDetailContainer = "_60-4";
export var detailWrapper = "_60-7";
export var dropdownButton = "_60-e";
export var dropdownTitle = "_60-9";
export var fullHeight = "_60-5";
export var hidden = "_60-a";
export var icon = "_60-b";
export var mergeSuggestionWrapper = "_60-m";
export var panel = "_60-i";
export var portalButtonsWrapper = "_60-c";
export var right = "_60-j";
export var tableSummaryContainer = "_60-8";
export var tableSummaryHeader = "_60-g";
export var threeDotsButton = "_60-f";
export var wide = "_60-h";